import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import supportDeskService from '../../services/supportDeskService';

const initialState = {
  articles: [],
  isLoading: false,
  error: null,
};

export const fetchArticles = createAsyncThunk(
  'knowledgeBase/fetchArticles',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await supportDeskService.getAllArticles(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch articles');
    }
  }
);

const knowledgeBaseSlice = createSlice({
  name: 'knowledgeBase',
  initialState,
  reducers: {
    clearKBError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArticles.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(fetchArticles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.articles = action.payload.results || action.payload;
        state.error = null;
      })
      .addCase(fetchArticles.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to fetch articles';
      });
  },
});

export const { clearKBError } = knowledgeBaseSlice.actions;
export default knowledgeBaseSlice.reducer;
